import { IDefineCommand, ICommand, IQuery, IQueryMediator } from 'core-ts-types';
import { UnscheduledSectionServant } from '../../unscheduled_sections/servants/unscheduled_section_servant';
import { ISection } from '../../../interfaces/scheduler_interfaces';
import * as _4 from 'lodash4';
import { SectionSwapServant } from '../../../swap/servants/section_swap_servant';
import { ScheduledSectionStatusServant } from '../../course_scheduler/servants/scheduled_section_status_servant';
import { TermScheduleFlags } from '../../course_scheduler/services/term_schedule_flags';
import { UpdateCalendarSectionTimesCommand } from '../../calendar/commands/update_calendar_section_times_command';

class SeatsInfo {
  private section: ISection;
  private availability: any;
  private isScheduled: boolean;
  private seatsText: string;
  private popoverText: string;
  private disableRefresh: boolean;
  private isUnlimitedSeating: boolean;
  private canAddToWaitlist: boolean = false;
  private customTooltip: string;
  private swapMode: boolean = false;
  private shouldShowSeatsInfo = false;
  private isSeatsRefreshEnabled = true;
  constructor(
    private ngUnscheduledSectionServant: UnscheduledSectionServant,
    private updateSeatAvailabilityCommand: ICommand,
    private $timeout: ng.ITimeoutService,
    private ngTermScheduleFlags: TermScheduleFlags,
    private ngSectionSwapServant: SectionSwapServant,
    private updateCalendarSectionTimesCommand: UpdateCalendarSectionTimesCommand,
    private ngScheduledSectionStatusServant: ScheduledSectionStatusServant
  ) {}
  initialize() {
    this.seatsText = this.getSeatsText();
    const lastUpdated =
      !_4.isUndefined(this.availability) && this.availability.last_refresh_ts
        ? `Last updated ${moment(this.availability.last_refresh_ts).fromNow()}`
        : ``;
    this.popoverText = `${lastUpdated}`;
    // TECH DEBT:
    // when dragging and not dropping into calendar ph3-tooltip in some way "loses" it's component properties and becomes only HTML.
    // So it stops working, no more hover behavior, no more tooltip and loses the styles that keep them hidden, so it just appears as a div breaking the layout. phx-tooltip is used instead
    this.customTooltip = `capability-ng-scheduler/src/views/components/seats_info_component/seats_info_component_tooltip.html`;
    this.isUnlimitedSeating = this.section.is_unlimited_seating;
    this.swapMode = this.ngSectionSwapServant.isInSwapMode();
    this.shouldShowSeatsInfo = !this.isSectionRegisteredInprogressCompleted();
    this.isSeatsRefreshEnabled = this.ngTermScheduleFlags.isOneClickRegistrationEnabled()
      ? !this.swapMode && !this.isUnlimitedSeating
      : false;
    this.canAddToWaitlist = this.ngUnscheduledSectionServant.canAddToWaitlist(this.section);
  }

  getSeatsText() {
    const availabeSeats = `${
      !_4.isUndefined(this.section._availability) ? this.section._availability.avail_seats : ''
    } Seat${this.section.seats_offered > 1 ? 's' : ''}`;
    if (this.section.is_unlimited_seating) {
      return 'Unlimited Seating';
    }
    // Read notes on SGD-13348
    if (
      this.ngScheduledSectionStatusServant.isStatusWaitlisted(this.section) &&
      this.ngUnscheduledSectionServant.isSectionFull(this.section) &&
      this.section.seats_offered > 0
    ) {
      return availabeSeats;
    }
    if (this.ngUnscheduledSectionServant.isSectionFull(this.section) && !this.canAddToWaitlist) {
      return `FULL`;
    }
    if (this.canAddToWaitlist) {
      return `Waitlist Available`;
    }
    return availabeSeats;
  }
  $onInit() {
    this.initialize();
  }
  $onChanges(changes: { section: any }) {
    this.initialize();
  }

  isSectionRegisteredInprogressCompleted() {
    return (
      this.ngScheduledSectionStatusServant.isRegisteredOrInprogress(this.section) ||
      this.ngScheduledSectionStatusServant.isCompleted(this.section) ||
      this.ngScheduledSectionStatusServant.isStatusWithdrawn(this.section)
    );
  }

  updateSectionTimesAndEnaleRefreshing() {
    this.disableRefresh = false;
    this.updateCalendarSectionTimesCommand();
  }

  refreshSeats() {
    const CLICK_DELAY = 15000;
    this.updateSeatAvailabilityCommand([this.section.id]).then(this.updateSectionTimesAndEnaleRefreshing.bind(this));
    this.disableRefresh = true;
    this.$timeout(this.updateSectionTimesAndEnaleRefreshing.bind(this), CLICK_DELAY);
  }
}

class SeatsInfoComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;
  constructor() {
    this.bindings = {
      section: '<',
      availability: '<',
      isScheduled: '<'
    };
    this.controller = SeatsInfo;
    this.templateUrl = 'capability-ng-scheduler/src/views/components/seats_info_component/seats_info_component.html';
  }
}
angular.module('capability-ng-scheduler').component('seatsInfo', new SeatsInfoComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/components/seats_info_component/seats_info_component.ts